module.exports = __webpack_public_path__ + "static/media/sign_up_bg.1b0b7fec.jpg";